import { OurNode } from "@src/cloud-connect/poc/our-node";
import { AlarmProfile } from "./alarm-profile";
import { AlarmRow } from "./alarm-row";
import { Alarm, AlarmTypeValue } from "./alarm";
import { Criteria, JoinOperatorValues } from "./criteria";
export interface ChannelsResponseTypes {
  data_id: number;
  tsid: string;
  namespace: string;
  group: string;
  source: string;
  data_type: string;
  mime_type: string;
  unit: number;
  name: string;
}
export class AlarmList {
  private alarmRows: AlarmRow[];
  private alarmProfile: AlarmProfile;
  private nodesetFlatMap: Map<string, OurNode>;
  private channelsResponse: ChannelsResponseTypes[];

  constructor(
    alarmProfile: AlarmProfile,
    nodesetFlatMap: Map<string, OurNode>,
    channelsResponse: ChannelsResponseTypes[],
  ) {
    this.setAlarmProfile(alarmProfile);
    this.setNodesetFlatMap(nodesetFlatMap);
    this.channelsResponse =
      channelsResponse && channelsResponse.length ? channelsResponse : [];

    if (alarmProfile) {
      this.alarmRows = this.calculateAlarmRows();
    } else {
      this.alarmRows = [];
    }
  }

  getAlarmRows() {
    return this.alarmRows;
  }

  setAlarmRows(alarmRows: AlarmRow[]) {
    this.alarmRows = alarmRows;
  }

  getAlarmRowByAlarmId(alarmId: string) {
    return this.alarmRows.find(
      (alarmRow) => alarmRow.getAlarm().getOurNode().id === alarmId,
    );
  }

  setAlarmProfile(alarmProfile: AlarmProfile) {
    this.alarmProfile = alarmProfile;
  }

  setNodesetFlatMap(nodesetFlatMap: Map<string, OurNode>) {
    this.nodesetFlatMap = nodesetFlatMap;
  }

  toggleAllAlarmRowActive(state) {
    this.alarmRows.forEach((alarmRow) => {
      alarmRow.setSelected(state);
    });
  }

  // !!!!! keep this function in case the channels strategy does not work

  /*   calculateAlarmRows() {
    const alarmRows = [];

    // Step 1: Create a Set of node IDs in nodesetFlatMap for efficient lookup
    const nodesetArray = Array.from(this.nodesetFlatMap.values());
    const nodesetNodeIds = new Set(nodesetArray.map((node) => node.id));

    // Step 2: Process alarms and add them to alarmRows with correct orphan flag
    const alarms = this.alarmProfile.getAlarms();
    alarms.forEach((alarm) => {
      const alarmNodeId = alarm.getOurNode().id;
      // If the node is in nodesetFlatMap, it's not orphaned; otherwise, it is orphaned
      const isOrphaned = !nodesetNodeIds.has(alarmNodeId);
      alarmRows.push(new AlarmRow(false, alarm, isOrphaned));
    });

    // Step 3: Add nodes in nodesetFlatMap that are not in alarms
    const alarmNodeIds = new Set(alarms.map((alarm) => alarm.getOurNode().id));
    nodesetArray.forEach((node) => {
      if (!alarmNodeIds.has(node.id)) {
        if (
          node.node_type === "VARIABLE" &&
          (node.attributes.data_type_as_string === "FLOAT" ||
            node.attributes.data_type_as_string === "BOOLEAN")
        ) {
          // For each remaining node in nodesetFlatMap, add a dummy alarm with isOrphanedAlarmNode = false
          alarmRows.push(
            new AlarmRow(
              false,
              new Alarm(node, new Criteria("OR", []), false, false, "numeric"),
              false,
            ),
          );
        } else if (
          node.node_type === "VARIABLE" &&
          node.attributes.data_type_as_string === "STRING"
        ) {
          alarmRows.push(
            new AlarmRow(
              false,
              new Alarm(node, new Criteria("OR", []), false, false, "string"),
              false,
            ),
          );
        }
      }
    });

    console.log("alarmRows", alarmRows);

    return alarmRows;
  } */

  calculateAlarmRows() {
    const alarmRows = [];

    // Step 1: Create a Map for quick lookup of `data_type` by `source`
    const channelMap = new Map(
      this.channelsResponse.map((channel) => [
        channel.source,
        channel.data_type,
      ]),
    );

    // Step 2: Get the Set of node IDs in nodesetFlatMap
    const nodesetArray = Array.from(this.nodesetFlatMap.values());
    const nodesetNodeIds = new Set(nodesetArray.map((node) => node.id));

    // Step 3: Process alarms and determine if they're orphaned
    const alarms = this.alarmProfile.getAlarms();
    const alarmNodeIds = new Set();

    alarms.forEach((alarm) => {
      const alarmNode = alarm.getOurNode();
      const alarmNodeId = alarmNode.id;

      // Check if the alarm is orphaned
      const isOrphaned = !nodesetNodeIds.has(alarmNodeId);

      // Get the `data_type` for the node from `channelMap`
      const dataType = channelMap.get(alarmNode.id);

      if (dataType && (dataType === "numeric" || dataType === "string")) {
        // Update `data_type` in the alarm and add it to alarmRows
        alarm.setDataType(dataType);
        alarmRows.push(new AlarmRow(false, alarm, isOrphaned));
        alarmNodeIds.add(alarmNodeId);
      }
    });

    // Step 4: Add orphaned nodes in nodesetFlatMap not in alarms
    nodesetArray.forEach((node) => {
      if (!alarmNodeIds.has(node.id)) {
        const dataType = channelMap.get(node.id);

        // Only add a new AlarmRow if `data_type` is `numeric` or `string`
        if (dataType && (dataType === "numeric" || dataType === "string")) {
          alarmRows.push(
            new AlarmRow(
              false,
              new Alarm(
                node,
                new Criteria(JoinOperatorValues.OR, []),
                false,
                AlarmTypeValue.SENSOR,
                dataType,
              ),
              false, // Not orphaned, as it comes from the flat map
            ),
          );
        }
      }
    });

    return alarmRows;
  }
}
